import { width } from "@fortawesome/free-brands-svg-icons/fa42Group";
import React from "react";
import { Card, Button } from "react-bootstrap";

export const ProductCard = ({ product }) => {
  return (
    <Card className="shadow-sm product-card">
      <Card.Img variant="top" src={product.image} style={{height:350}} className="border img-fluid card-img-top" />
      <Card.Body className="text-center">
        <Card.Title>{product.title}</Card.Title>
        <Card.Text className="text-muted">{product.price}</Card.Text>
        {/* <Button variant="primary" className="rounded-pill px-3"> 
          Add to Cart
        </Button>*/}
      </Card.Body>
    </Card>
  );
};
export default ProductCard;


{/* <Card className="product-card shadow-sm rounded-4 h-100">
                      <Card.Img variant="top" src={item.img} className="rounded-top-4" />
                      <Card.Body>
                        <p className="text-muted mb-1">{item.category}</p>
                        <Card.Title>{item.title}</Card.Title>
                        <Card.Text>{item.description}</Card.Text>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div className="d-flex align-items-center">
                            <img
                              src={item.authorImg}
                              alt={item.author}
                              className="rounded-circle border me-2"
                              width="40"
                            />
                            <small className="fw-bold">{item.author}</small>
                          </div>
                          <Button variant="primary" className="rounded-pill px-3">Add to Cart</Button>
                        </div>
                      </Card.Body>
                    </Card> */}

